

import { Check, CheckCircleOutlined, InfoOutlined } from '@mui/icons-material';

import DataGridHeader from 'components/dataGridHeader';
import { Status } from './Documents.styles';

import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';


import { toShortDate } from 'utility/datetimeFormatting';
import { getLabelForPaymentMethod } from 'utility/paymentMethods';
import navigationPaths from 'engine/navigationPaths';

import * as Styled from './Documents.styles';
import NoRowsOverlay from 'components/noRowsOverlay/customNoRowsOverlay';

export const Documents = ({ data }) => {
  const navigate = useNavigate();

  function getItemIndex(data) {
    return data.api.getRowIndex(data.row.id) + 1;
  }

  function getInvoicePaymentName(data) {
    const paymentLabel = getLabelForPaymentMethod(data.row.paymentCode);
    return paymentLabel;
  }

  const renderColHeader = (params) => <DataGridHeader>{params.colDef.headerName}</DataGridHeader>;

  const columns = [
    {
      field: 'index',
      headerName: 'ID',
      width: 70,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      disableColumnMenu: true,
      renderHeader: renderColHeader,
      valueGetter: getItemIndex
    },
    {
      field: 'fullNumber',
      headerName: 'Numer',
      flex: 0.5,
      minWidth: 100,
      sortable: false,
      disableColumnMenu: true,

      renderCell: (props) => {
        const goToDocument = () =>
          props.row.documentType === 'INVOICE'
            ? navigate(navigationPaths().InvoicesPreview, { state: { id: props.row.id } })
            : props.row.documentType === 'CORRECTION_INVOICE'
            ? navigate(navigationPaths().CorrectionInvoicesPreview, { state: { id: props.row.id } })
            : props.row.documentType === 'PROFORMA'
            ? navigate(navigationPaths().ProformasPreview, { state: { mode: 'preview', id: props.row.id } })
            : props.row.documentType === 'COST_INVOICE'
            ? navigate(navigationPaths().CostInvoicesFormPreview.replace(':costId', props.row.id), {
                state: { mode: 'preview', id: props.row.id },
              })
            : null;
        return (
          <Styled.NumberField className={classnames({ active: !!props.row.documentType })} onClick={goToDocument}>
            {props.row.fullNumber !== '' ? props.row.fullNumber : '<brak>'}
          </Styled.NumberField>
        );
      },
    },
    {
      field: 'buyerName',
      headerName: 'Klient',
      minWidth: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,

      renderHeader: renderColHeader,

      valueFormatter: (props) => {
        return props.value !== '' ? props.value : '<brak>';
      },

    },
    {
      field: 'dateOfIssueUtc',
      headerName: 'Data wystawienia',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderHeader: renderColHeader,
      valueFormatter: (props) => {
        return toShortDate(props.value);
      },
    },
    {
      field: 'paymentDueDateUtc',
      headerName: 'Data płatności',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderHeader: renderColHeader,
      valueFormatter: (props) => {
        return props.value === null ? '' : toShortDate(props.value);
      },
    },
    {
      field: 'amountToPayNet',
      headerName: 'Wartość netto',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderHeader: renderColHeader,
    },
    {
      field: 'amountToPay',
      headerName: 'Wartość brutto',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderHeader: renderColHeader,
    },
    {
      field: 'paymentCode',
      headerName: 'Płatność',
      width: 100,
      sortable: false,
      disableColumnMenu: true,

      renderHeader: renderColHeader,
      valueGetter: getInvoicePaymentName
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      renderHeader: renderColHeader,
      renderCell: (props) => (
        <>
          {props.row.isPaid === true ? (
            <Styled.Status>
              <Styled.StatusIcon className="success">
                <Check />
              </Styled.StatusIcon>
              Opłacono
            </Styled.Status>
          ) : props.row.isPaid === false ? (
            <Styled.Status>
              <Styled.StatusIcon className="warning">i</Styled.StatusIcon>
              Nieopłacono
            </Styled.Status>
          ) : null}
        </>
      ),
    },
  ];

  return (
    <Styled.Wrapper>
      <Styled.Title>Ostatnie dokumenty</Styled.Title>

      <Styled.DataGrid rows={data} columns={columns} autoHeight hideFooterPagination hideFooterSelectedRowCount hideFooter  
            components={{
              NoRowsOverlay: NoRowsOverlay
            }}/>
    </Styled.Wrapper>
  );
};
